var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2993_483)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 24,
    fill: "url(#paint0_linear_2993_483)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.75 16H29C28.6022 16 28.2206 16.158 27.9393 16.4393C27.658 16.7206 27.5 17.1022 27.5 17.5V32.5C27.5 32.8978 27.658 33.2794 27.9393 33.5607C28.2206 33.842 28.6022 34 29 34H32.75C33.1478 34 33.5294 33.842 33.8107 33.5607C34.092 33.2794 34.25 32.8978 34.25 32.5V17.5C34.25 17.1022 34.092 16.7206 33.8107 16.4393C33.5294 16.158 33.1478 16 32.75 16ZM32.75 32.5H29V17.5H32.75V32.5ZM23 16H19.25C18.8522 16 18.4706 16.158 18.1893 16.4393C17.908 16.7206 17.75 17.1022 17.75 17.5V32.5C17.75 32.8978 17.908 33.2794 18.1893 33.5607C18.4706 33.842 18.8522 34 19.25 34H23C23.3978 34 23.7794 33.842 24.0607 33.5607C24.342 33.2794 24.5 32.8978 24.5 32.5V17.5C24.5 17.1022 24.342 16.7206 24.0607 16.4393C23.7794 16.158 23.3978 16 23 16ZM23 32.5H19.25V17.5H23V32.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 46,
    height: 46,
    rx: 23,
    stroke: "url(#paint1_linear_2993_483)",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2993_483",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.101961 0 0 0 0 0.164706 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2993_483"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2993_483",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2993_483",
    x1: 50,
    y1: 1,
    x2: 2,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB3B5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465749,
    stopColor: "#8937A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#455AC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2993_483",
    x1: 50,
    y1: 1,
    x2: 2,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E28A9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#D378F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A9CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/Pause.efeccc425174ee42a7425b35d72caeab.svg";
export { ForwardRef as ReactComponent };